<template>
  <div class="static">
    <div class="grid grid-cols-2 gap-4"
      :class="{
        'md:grid-cols-3': columns == 3,
        'md:grid-cols-4': columns == 4,
        'md:grid-cols-5': columns == 5,
        'md:grid-cols-6': columns == 6,
      }">
      <div
        v-for="(photo, index) in photoData"
        :key="photo.url"
        :id="'gallery_thumbnail_' + photo.name"
        class="cursor-pointer group"
        @click="openPhoto(index)"
        @keydown.enter="openPhoto(index)"
      >
        <div
          class="block w-full bg-gray-300 bg-center bg-cover ring-4 ring-transparent ring-inset hover:ring-accent transition-color duration-700  dark:shadow-primary-dark hover:shadow-xl" tabindex="0"
          :class="{
            'rounded-xl shadow-xl': format != 0,
            'aspect-square': aspect == 'square',
            'aspect-[7/5]': aspect == 'image',
            'aspect-[4/3]': aspect == ''
          }"
          v-lazy:background-image="photo.sizes.large ? photo.sizes.large : photo.url"
          :alt="photo.alt"
        ></div>
        <div v-if="captions != 0" class="text-primary font-bold text-center py-2 mb-4" >{{ photo.caption }}</div>
      </div>
    </div>

    <teleport to="#popup-target">
      <div v-if="popupOpen" class="fixed z-50 top-0 h-screen w-full bg-white backdrop-blur bg-opacity-80 p-8 flex flex-col justify-center" >
        <div class="relative px-4 pb-4 w-full h-full">
          <span @click="closePhotoBrowser()" @keydown.enter="closePhotoBrowser()" class="absolute flex items-center leading-none h-10 px-6 bg-primary hover:bg-accent shadow-xl right-4 top-6 lg:right-10 cursor-pointer text-white rounded-full" tabindex="4"  >
            <svg-vue icon="times" class="fill-current h-3 w-3 mr-2 leading-none" ></svg-vue>
            close
          </span>
          <div class="flex-grow lg:h-full w-full flex justify-center items-center pt-20 lg:py-12">
            <img
              id="popoverimage"
              @keydown.esc="closePhotoBrowser()"
              @keydown.space="nextPhoto"
              :src="activePhoto.url"
              :alt="activePhoto.alt + ' (use space bar to advance photos and esc to close gallery)'"
              class="max-h-full max-w-full mx-auto "
              tabindex="1"
            >
          </div>

          <div class="relative max-w-xs mx-auto bg-gray-100 rounded-full shadow-xl flex justify-between mt-4 lg:-mt-8 p-1 z-20" >
            <span @click="prevPhoto" @keydown.enter="prevPhoto" class="h-10 px-6 bg-primary hover:bg-accent text-white flex items-center leading-none cursor-pointer focus:outline-accent rounded-full" tabindex="2"  >prev</span>
            <span class="text-gray-700 font-bold flex items-center leading-none"> {{ activeIndex + 1 }} of {{ photoData.length }}</span>
            <span @click="nextPhoto" @keydown.enter="nextPhoto" class="h-10 px-6 bg-primary hover:bg-accent text-white flex items-center leading-none cursor-pointer focus:outline-accent rounded-full" tabindex="3"  >next</span>
          </div>

        </div>

      </div>
    </teleport>
  </div>
</template>
<script>
export default {
  name: 'PhotoGallery',

  props: {
    photos: {
      type: Object,
      default: () => {}
    },
    aspect: {
      type: String,
      default: 'square'
    },
    captions: {
      type: Number,
      default: 0
    },
    columns: {
      type: Number,
      default: 2
    },
    format: {
      type: Number,
      default: 0
    },
  },

  data () {
    return {
      activePhoto: {},
      photoData: [],
      popupOpen: false,
      activeIndex: 0
    }
  },

  mounted () {
    this.photoData = this.photos
  },

  methods: {
    openPhoto (num) {
      this.popupOpen = true
      this.activeIndex = num
      this.activePhoto = this.photoData[num]

      this.$nextTick(() => {
        document.getElementById('popoverimage').focus()
      })
    },

    nextPhoto () {
      if((this.activeIndex+1) == this.photoData.length){
        this.activeIndex = 0
      } else {
        this.activeIndex++
      }

      this.openPhoto(this.activeIndex)
    },

    prevPhoto () {
      if((this.activeIndex+1) == 1){
        this.activeIndex = this.photoData.length
      } else {
        this.activeIndex--
      }

      this.openPhoto(this.activeIndex)
    },

    closePhotoBrowser () {
      this.popupOpen = false

      this.$nextTick(() => {
        document.getElementById('gallery_thumbnail_' + this.activePhoto.name).focus()
      })
    }
  }

}
</script>
